// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.FilterItemActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import { withHandlers } from 'recompose';
import FilterProps from '../PropertiesBuilder/Izenda.FilterProps';
import { CALCULATED_FIELD_NAME, FIELD_TYPE } from 'logic/data/Izenda.ReportDesignerConstants';
import { EMPTY_GUID } from 'logic/data/Izenda.AppGlobalConstants';
import QuerySourceTypeConfig from 'logic/data/Izenda.QuerySourceTypeConfig';
import { concat, forEach, get, filter, map, uniq, some, flatMap, flow, first, contains } from 'lodash/fp';
const { TABLE, STORED_PROC, VIEW } = QuerySourceTypeConfig.QUERY_SOURCE_TYPE;

/**
 * Remove filter item
 */
const removeFilterItem = (props: any) => () => {
  const { store, itemData, validation } = props;
  const reportFilters = store.reportFilters || {};

  store.updateReportDesignerCascadingFilter(itemData);
  reportFilters.removeFilter && reportFilters.removeFilter(itemData);
  store.reportFilters.setConfigModeToField(null);
  validation.validate();


};

/**
 * Open filter properties popup
 */
const openFilterPropertiesPopup = (props: any) => () => {
  const { store } = props;

  props.openPopup(FilterProps, {
    reportDesignerModel: store.masterModel,
    fieldStore: store
  });
};

/**
 * check valid filter
 */
const checkValidFilter = (props: any) => () => {
  const {
    store,
    itemData: { sourceFieldVisible, sourceFieldFilterable, querySourceType, querySourceFieldId }
  } = props;
  const isValidFilterSource = checkValidFilterSource(querySourceFieldId, store);
  const isValidFilterForCalculatedField = checkIsValidFilterForCalculatedField(querySourceFieldId, store);
  switch (querySourceType) {
    case TABLE:
    case STORED_PROC:
    case VIEW:
      return sourceFieldVisible && sourceFieldFilterable && isValidFilterSource;
    case CALCULATED_FIELD_NAME:
      return sourceFieldVisible && isValidFilterForCalculatedField;
    case FIELD_TYPE.AggregatedField:
      return sourceFieldVisible && sourceFieldFilterable;
    default:
      return false;
  }
};

/**
  check if a filter field is valid or not in it's data source.
 */
const checkValidFilterSource = (filterFieldId: string, store: any) => {
  if (!filterFieldId) {
    return false;
  }
  let allFieldsInDataSources = getAllFieldOnDataSources(store);
  return some({ id: filterFieldId }, allFieldsInDataSources);
};

/**
  check matched sources between data source in calculated field and valid data source tree.
 */
const checkIsValidFilterForCalculatedField = (filterId: string, store: any) => {
  const listFieldSourcesIdInCalculatedField = flow(
    get('fieldQuerySource'),
    filter({ name: CALCULATED_FIELD_NAME }),
    flatMap(s => s.fields),
    filter({ id: filterId }),
    first,
    get('expressionFields'),
    map('querySourceId'),
    filter(x => x !== EMPTY_GUID)
  )(store);

  const allDataSourcesId = uniq(map('querySourceId', getAllFieldOnDataSources(store)));
  return listFieldSourcesIdInCalculatedField.every(calcFieldDs => contains(calcFieldDs, allDataSourcesId));
};

/**
  get all field on data sources
 */
const getAllFieldOnDataSources = (store: any) => {
  let allFieldsInDataSources = [];
  forEach(item => {
    allFieldsInDataSources = concat(allFieldsInDataSources, item.fields.toJS());
  }, get('dataTree.details[0].querySource', store));
  return allFieldsInDataSources;
};

export default withHandlers({
  removeFilterItem,
  openFilterPropertiesPopup,
  checkValidFilter
});



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/Filter/Izenda.FilterItemActions.js